/* @flow */

import {useGetSessionUser} from '../../../../core/use-get-session-user';
import {useUpdateUserSetting} from '../../../../core/use-update-user-setting';

type UnlockConfirmation = {
    shouldShow: boolean,
    onHideUnlockConfirmation: () => Promise<*>,
};

export const useShowUnlockConfirmation = (): {
    unlockConfirmation: ?UnlockConfirmation,
    isLoading: boolean,
    error: ?string,
} => {
    const {user, isLoading, errorMessage: error} = useGetSessionUser();
    const updateUserSetting = useUpdateUserSetting();

    const unlockConfirmation = user
        ? {
              shouldShow: !user.hasDismissedCompanyUnlockConfirmation,
              onHideUnlockConfirmation: () =>
                  updateUserSetting({
                      userId: user.id,
                      settingName: 'hide_company_unlock_confirmation',
                      value: '1',
                      propertyOnUser: 'hasDismissedCompanyUnlockConfirmation',
                  }),
          }
        : undefined;

    return {
        isLoading,
        error,
        unlockConfirmation,
    };
};
